import React from 'react';
import Dialog from 'ui/dialog';
import { stateFix } from 'logic/stateReducers';
import Tooltip from 'ui/tooltip';
import Store from 'store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { OverlayContext } from 'ui/utils/OverlayManager';

function NewConfirmation({ onResolve, onClose }) {
  return (
    <Dialog title={`New profile`} modal onClose={onClose}>
      <Dialog.Content>
        <p>{`Delete all data and start from a blank profile?`}</p>
      </Dialog.Content>
      <Dialog.Footer>
        <button onClick={() => onResolve(true)}>{`Yes`}</button>
        <button onClick={() => onResolve(false)}>{`No`}</button>
      </Dialog.Footer>
    </Dialog>
  );
}

export default function ProfileNewButton() {
  const isEmpty = Store.useSelector(state => !state.builder);
  const imported = Store.useSelector(state => state.imported);
  const dispatch = Store.useDispatch();
  const overlays = React.useContext(OverlayContext);
  const onClick = React.useCallback(async () => {
    if (imported !== true && !await overlays.async(<NewConfirmation/>)) return;
    dispatch.setState(stateFix());
  }, [dispatch, overlays, imported]);
  if (isEmpty) return null;
  return (
    <Tooltip tooltip={`New profile`}>
      <FontAwesomeIcon icon={faFile} onClick={onClick}/>
    </Tooltip>
  );
}
